export const waitPromise = ms => new Promise(resolve => setTimeout(resolve, ms));

export const updaterGen = (propsAttr = [], stateAttr = []) => function (nextProps, nextState) {
  // Testa as props
  const shouldUpdate = propsAttr && propsAttr.reduce((prev, next) => {
    if (prev || nextProps[next] !== this.props[next]) return true;
    return prev;
  }, false);

  // Testa o state
  return shouldUpdate || stateAttr && stateAttr.reduce((prev, next) => {
    if (prev || nextState[next] !== this.state[next]) return true;
    return prev;
  }, false);
};

export const setFieldValueGen = (component, property = 'template') => (key, value) => {
  const update = { [property]: { ...component.state[property], [key]: value } };
  component.setState(update);
};



// WEBPACK FOOTER //
// ./src/helpers/utils.js